import services from './services';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';

export default {
    mixins: [services],
    data() {
        return {
            loading: false,
            dialogVisible: false,
            title: '',
            form: this.getFormData(),
            classType: [{
                id: 1,
                name: '托班'
            }, {
                id: 2,
                name: '小班'
            }, {
                id: 4,
                name: '中班'
            }, {
                id: 8,
                name: '大班'
            }, {
                id: 16,
                name: '学前班'
            }]
        }
    },
    methods: {
        getFormData() {
            return cloneDeep({
                "Id": 0,
                "SchoolId": 0,
                "ClassName": "",
                "Grade": "",
                "MainTeacherPhone": '',
                "MainTeacherName": '',
                ProjectType: 1,
                IsSchedule: 1
            })
        },
        show(options) {
            this.form = this.getFormData()
            this.dialogVisible = true
            this.title = options.title
            this.form.SchoolId = options.SchoolId

        },
        // 确定
        submit() {
            let checkRules = [{
                name: "班级名称",
                value: this.form.ClassName,
                required: true,
            }, {
                name: "班级年段",
                value: this.form.Grade,
                required: true,
                msg: '请选择班级年段'
            }, {
                name: "班主任姓名",
                value: this.form.MainTeacherName,
                required: true,
            }, {
                name: "班主任电话",
                value: this.form.MainTeacherPhone,
                required: true,
            }];
            if (this.form.MainTeacherPhone !== '') {
                checkRules.push({
                    name: "班主任电话",
                    value: this.form.MainTeacherPhone,
                    phone: true,
                })
            }
            var flag = util.checkForm({
                ele: this,
                rules: checkRules
            });
            if (!flag) {
                return
            }
            this.ZqwPlatform_EditClass()
        }


    },
    computed: {

    }
}


// WEBPACK FOOTER //
// ./src/pages/SchoolOrder/components/addClass/vm.js